// src/components/AppDownload.js

import React from 'react';
import styles from './AppDownload.module.css';

import GooglePlayBadge from '../assets/Group-27652.png';
import AppStoreBadge from '../assets/Group-27651.png';

const AppDownload = () => {
  return (
    <div className={styles.appContainer}>
      <div className={styles.cardContainer}>
        {/* Logo area */}
        <div className={styles.logoWrapper}>
          <img
            src={`https://img.ironbhai.com/static/Iron-Bhai.png`}
            alt="IronBhai Logo"
          />
        </div>

        {/* Text content */}
        <div className={styles.contentWrapper}>
          <h1 className={styles.headline}>Download the IronBhai App</h1>
          <p className={styles.subtext}>
            Laundry & ironing services at your fingertips. Book, schedule & relax. Anytime. Anywhere.
          </p>
        </div>

        {/* Store links - now just images */}
        <div className={styles.storeLinks}>
          <a
            href="https://play.google.com/store/apps/details?id=com.ironbhaiuser"
            className={styles.storeBtn}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={GooglePlayBadge} alt="Google Play" />
          </a>
          <a
            href="https://apps.apple.com/in/app/iron-bhai/id6751038071"
            className={styles.storeBtn}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={AppStoreBadge} alt="App Store" />
          </a>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          &copy; 2025 IronBhai. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default AppDownload;